import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  fetchIndizes,
  fetchAktienByIndex,
  selectIndex,
  selectAllIndizes,
  selectIndizesStatus,
  selectSelectedIndex,
  selectIndexAktien,
  selectAktienStatus,
} from 'modules/aktien/features/indizesSlice';
import { fetchWatchlists } from 'modules/aktien/features/watchlistsSlice';
import AktienTabelle from 'modules/aktien/components/AktienTabelle';

/**
 * Ansicht „Indizes": oben Index-Auswahl (Chips), darunter die Aktien-Tabelle
 * des gewählten Index. Die Kurse werden bei jedem Aufruf LIVE von OnVista
 * geholt (nicht aus der DB).
 */
export default function IndizesView() {
  const dispatch = useDispatch();
  const indizes = useSelector(selectAllIndizes);
  const indizesStatus = useSelector(selectIndizesStatus);
  const selectedIndex = useSelector(selectSelectedIndex);
  const aktien = useSelector(selectIndexAktien);
  const aktienStatus = useSelector(selectAktienStatus);

  // Initial: Indizes + Watchlists laden (Watchlists für das "+ zu Liste"-Menü).
  useEffect(() => {
    if (indizesStatus === 'idle') {
      dispatch(fetchIndizes());
    }
    dispatch(fetchWatchlists());
  }, [dispatch, indizesStatus]);

  // Aktien des gewählten Index live nachladen (bei jedem Wechsel / Seitenaufruf).
  useEffect(() => {
    if (selectedIndex) {
      dispatch(fetchAktienByIndex(selectedIndex));
    }
  }, [dispatch, selectedIndex]);

  return (
    <div>
      <header className="mb-6">
        <h1 className="font-serif text-3xl font-semibold text-ink">Indizes</h1>
        <p className="mt-1 text-sm text-ink-muted">
          Wähle einen Index – die Kurse werden live von OnVista abgerufen.
        </p>
      </header>

      {indizesStatus === 'loading' && <p className="text-ink-muted">Lade Indizes…</p>}
      {indizesStatus === 'failed' && (
        <p className="text-loss">Indizes konnten nicht geladen werden.</p>
      )}

      {/* Index-Auswahl als Chips */}
      <div className="mb-8 flex flex-wrap gap-2">
        {indizes.map((idx) => {
          const aktiv = idx.name === selectedIndex;
          return (
            <button
              key={idx.name}
              type="button"
              onClick={() => dispatch(selectIndex(idx.name))}
              title={idx.beschreibung}
              className={`rounded-full px-4 py-1.5 text-sm font-medium transition-colors ${
                aktiv
                  ? 'bg-ink text-paper'
                  : 'border border-line bg-paper-soft text-ink-soft hover:bg-ink/5'
              }`}
            >
              {idx.anzeigeName || idx.name}
            </button>
          );
        })}
      </div>

      {/* Aktien-Tabelle (live) */}
      {aktienStatus === 'failed' ? (
        <p className="rounded-xl border border-dashed border-loss/30 bg-loss/5 p-8 text-center text-loss">
          Live-Kurse konnten nicht abgerufen werden. Bitte später erneut versuchen.
        </p>
      ) : aktienStatus === 'loading' ? (
        <p className="text-ink-muted">Lade Live-Kurse…</p>
      ) : (
        <AktienTabelle aktien={aktien} />
      )}
    </div>
  );
}
